import {ModelType, ModelTypeCompatibilityMap} from '~/enums/modelType'
import {GenericType} from '~/interfaces/genericTypeInterfaces'
import DefaultImposterMapFactory from '~/models/imposterMapFactories/defaultImposterMapFactory'
import {IImposterMap, IImposterOptions} from '~/interfaces/imposterInterfaces'

interface IDestination {
  modelType: ModelType
  genericType: GenericType
}
interface ISource {
  modelType: ModelType
  genericType: ModelType
}

/**
 * Use this function if all you need are some of the common checks for determine imposter type
 * @param destination
 * @param source
 * @param options
 * @constructor
 */
export function commonImposterMap({
                                    destination,
                                    source,
                                    options,
                                  }: { destination: IDestination, source: ISource, options?: IImposterOptions }): IImposterMap | null {
  if (commonTypeCheck(destination, source, ModelType.User)) {
    return new DefaultImposterMapFactory().imposterMapFor({ modelType: ModelType.User, options })
  } else if (commonTypeCheck(destination, source, ModelType.Email)) {
    return new DefaultImposterMapFactory().imposterMapFor({ modelType: ModelType.Email, options })
  } else if (commonTypeCheck(destination, source, ModelType.Text)) {
    return new DefaultImposterMapFactory().imposterMapFor({ modelType: ModelType.Text, options })
  } else if (commonTypeCheck(destination, source, ModelType.DateTime)) {
    return new DefaultImposterMapFactory().imposterMapFor({ modelType: ModelType.DateTime, options })
  } else if (commonTypeCheck(destination, source, ModelType.File)) {
    return new DefaultImposterMapFactory().imposterMapFor({ modelType: ModelType.File, options })
  } else if (commonTypeCheck(destination, source, ModelType.Number)) {
    return new DefaultImposterMapFactory().imposterMapFor({modelType: ModelType.Number, options })
  } else if (commonTypeCheck(destination, source, ModelType.Boolean)) {
    return new DefaultImposterMapFactory().imposterMapFor({modelType: ModelType.Boolean, options })
  } else {
    return null
  }
}

function checkForType(destination: IDestination, type: ModelType) {
  return [destination.modelType, destination.genericType].includes(type)
}

function commonTypeCheck(destination: IDestination, source: ISource, type: ModelType) {
  return checkForType(destination, type) && (isMappable(type, source.modelType) || isMappable(type, source.genericType))
}

function isMappable(destinationType: ModelType, sourceType: ModelType): boolean {
  return ModelTypeCompatibilityMap(destinationType).includes(sourceType)
}